import React from "react";
import { Link } from "react-router-dom";

const Button = ({ title, page }) => {
  return (
    <Link to={page}>
      <button className="bg-[#FF4C3B] px-[56px] py-[24px] text-white rounded-full cursor-pointer font-san font-[28px]  hover:scale-105  transition duration-700 ease-in-out">
        {/* Explore Products */}
        {title}
      </button>
    </Link>
  );
};

export default Button;
